import React, { useState } from "react";
import { useGetTickets } from "../../../hooks/Administrative/useGetTickets";
import { useGetFilters } from "../../../hooks/Administrative/useGetFilters";
import TableView from "../../../components/TableView/TableView";
import TicketInfo from "../../../components/TicketInfo/TicketInfo";
import {Bounce, toast} from "react-toastify";
import SupervisorTicketInfo from "../../../components/SupervisorTicketInfo/SupervisorTicketInfo";

const columns = ['CLIENTE', 'PLANTA', 'SERVICIO', 'ESTADO', 'CLAVE DE TICKET'];

const SupervisorTickets = () => {
    const [selectedTicket, setSelectedTicket] = useState<string>('');
    const [showTicketInfo, setShowTicketInfo] = useState<boolean>(false);
    const [additionalInfo, setAdditionalInfo] = useState<any>(null);
    const [filters, setFilters] = useState({});
    const { tickets, totalPages, isLoading, page, setPage, updateTicketStateLocally } = useGetTickets({ filters });
    const { clients, services, states } = useGetFilters();

    const handleOnRowClick = (row: Record<string, any>) => {

        if(row['ESTADO'] === 'Rechazado'){
            toast.warning(
                'El ticket al haber sido rechazado, fue borrado del sistema.',
                {
                    position: 'top-right',
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false,
                    theme: 'colored',
                    transition: Bounce,
                }
            );
        }
        else{
            setSelectedTicket(row['CLAVE DE TICKET']);
            setAdditionalInfo(row);
            setShowTicketInfo(true);
        }
    };

    const handleBack = () => {
        setShowTicketInfo(false);
    };

    return showTicketInfo ? (
        <SupervisorTicketInfo
            ticketCode={selectedTicket}
            onBack={handleBack}
            additionalInfo={additionalInfo}
            showTicketInfo={setShowTicketInfo}
            updateTicketStateLocally={updateTicketStateLocally}
        />
    ) : (
        <TableView
            title="TICKETS"
            columns={columns}
            filters={filters}
            tickets={tickets}
            totalPages={totalPages}
            isLoading={isLoading}
            page={page}
            clients={clients}
            services={services}
            states={states}
            setFilters={setFilters}
            setPage={setPage}
            disableAddButton={true}
            onRowClick={handleOnRowClick}
        />
    );
};

export default SupervisorTickets;
